import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

export default function Portal({ children, className, style }) {
  useEffect(() => {
    return () => {};
  }, []);

  const container = document.body;
  return ReactDOM.createPortal(
    <div className={className} style={style}>
      {children}
    </div>,
    container
  );
}
